import { Card, CardContent, Button, Grid, IconButton, TableCell, TableRow } from '@mui/material';
import { Layout } from 'components/layout';
import BaseTablePaginator from 'components/table/BaseTablePaginator';
import { PaginateRequest } from 'interfaces/api-request';
import { Order } from 'interfaces/table';
import { useGetSubCompaniesPaginateQuery } from 'lib/api/admin/adminSubCompanyApi';
import React, { useEffect, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDeleteLeaveFlowMutation, useGetLeaveFlowsPaginateQuery } from 'lib/api/admin/adminLeaveFlowApi';
import CreateLeaveFlowDialog from '../components/CreateLeaveFlowDialog';
import { LeaveFlow } from 'interfaces/leave-flow';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import EditLeaveFlowDialog from '../components/EditLeaveFlowDialog';

const AdminLeaveFlowPage = () => {
    const [order, setOrder] = useState<Order>('asc');
    const [orderBy, setOrderBy] = useState<string>();
    useEffect(() => {
        setPaginateRequest({ ...paginateRequest, order: order });
    }, [order]);
    useEffect(() => {
        setPaginateRequest({ ...paginateRequest, order_by: orderBy });
    }, [orderBy]);
    const [paginateRequest, setPaginateRequest] = useState<PaginateRequest & { work_category_type?: string }>({
        current_page: 0,
        per_page: 10,
        order: order
    });
    const { isLoading, error, data, isFetching } = useGetLeaveFlowsPaginateQuery({
        ...paginateRequest,
        current_page: +paginateRequest.current_page! + 1
    });

    const [selectedLeaveFlow, setSelectedLeaveFlow] = useState<LeaveFlow>();
    const [openDialogCreateLeaveFlow, setOpenDialogCreateLeaveFlow] = useState(false);
    const [openDialogEditLeaveFlow, setOpenDialogEditLeaveFlow] = useState(false);

    //delete data
    const [deleteLeaveFlow] = useDeleteLeaveFlowMutation();
    const handleDelete = (leaveFlow: LeaveFlow) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Are you sure?',
            text: 'You will delete this item!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete item!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteLeaveFlow({ id: leaveFlow.id ?? '' })
                    .unwrap()
                    .then((res) => {
                        MySwal.fire('Sukses', 'Data berhasil dihapus!', 'success');
                    })
                    .catch((err) => {
                        console.error(err.message ? err.message : err.data.message);
                        MySwal.fire('Gagal', err.message ? err.message : err.data.message, 'error');
                    });
            }
        });
    };

    return (
        <Layout headerTitle="Leave Flow" pageTitle="Leave Flow" disableBreadcrumb>
            <Grid container direction={'column'} spacing={20}>
                <Grid item>
                    <Card>
                        <CardContent>
                            <Grid container direction={'column'} spacing={20}>
                                <Grid item container justifyContent="flex-end" spacing={8}>
                                    <Grid item>
                                        <Button
                                            variant="outlined"
                                            onClick={(val) => {
                                                setOpenDialogCreateLeaveFlow(true);
                                            }}
                                        >
                                            Add Leave Flow
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <BaseTablePaginator
                                        isLoading={isLoading || isFetching}
                                        count={data?.meta.total ?? 0}
                                        rowsPerPage={+paginateRequest.per_page!}
                                        page={+paginateRequest.current_page!}
                                        onPageChange={function (
                                            event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
                                            newPage: number
                                        ): void {
                                            setPaginateRequest({ ...paginateRequest, current_page: newPage });
                                        }}
                                        onRowsPerPageChange={function (
                                            event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                                        ): void {
                                            setPaginateRequest({
                                                ...paginateRequest,
                                                current_page: 0,
                                                per_page: parseInt(event.target.value, 10)
                                            });
                                        }}
                                        onSearchchange={function (e: string): void {
                                            setPaginateRequest({ ...paginateRequest, q: e, current_page: 0 });
                                        }}
                                        orderBy={orderBy}
                                        order={order}
                                        onRequestSort={(newOrderBy, newOrder) => {
                                            setOrderBy(newOrderBy);
                                            setOrder(newOrder);
                                            setPaginateRequest({ ...paginateRequest, current_page: 0 });
                                        }}
                                        headCells={[
                                            { id: 'department_id', label: 'Department', isSortable: true },
                                            { id: 'approver_1', label: 'Approver 1', isSortable: true },
                                            { id: 'approver_2', label: 'Approver 2', isSortable: true },
                                            { id: 'approver_3', label: 'Approver 3', isSortable: true },
                                            { id: 'action', label: 'Actions', isSortable: false }
                                        ]}
                                    >
                                        {data?.data?.map((row) => (
                                            <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell component="th" scope="row">
                                                    {row.department.name}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row.approver1?.first_name} {row.approver1?.last_name}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row.approver2?.first_name} {row.approver2?.last_name}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row.approver3?.first_name} {row.approver3?.last_name}
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => {
                                                            setSelectedLeaveFlow(row);
                                                            setOpenDialogEditLeaveFlow(true);
                                                        }}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => {
                                                            handleDelete(row);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </BaseTablePaginator>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            {!isLoading && (
                <>
                    <CreateLeaveFlowDialog
                        open={openDialogCreateLeaveFlow}
                        handleClose={() => {
                            setOpenDialogCreateLeaveFlow(false);
                        }}
                    />
                    {selectedLeaveFlow && (
                        <EditLeaveFlowDialog
                            open={openDialogEditLeaveFlow}
                            handleClose={() => {
                                setOpenDialogEditLeaveFlow(false);
                            }}
                            leaveFlow={selectedLeaveFlow}
                        />
                    )}
                </>
            )}
        </Layout>
    );
};

export default AdminLeaveFlowPage;
